import usePrivateLink from "../../config/usePrivateLink";
import React, { useState, useEffect } from "react";
import Header from "../../master/SideBar";
import Footer from "../footer";
import Nav from "../../master/NavBar";
import { getBatchList } from "../../../api/BatchService";
import {
  attendanceBatchStudentsPost,
  SinglePresent,
  StudentBatchList,
  studentsAttendance,
} from "../../../api/StudentsAttendance";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { getSessions } from "../../../api/SessionsService";
import { viewlist } from "../../../api/BatchService";
import { ToastMain, SweetAlertShow } from "../../master/Master";
import Swal from "sweetalert2";
import {
  StudentAttendence,
  StudentAttendenceAbsent,
} from "../../../api/WpServices";
import DownloadExcel from "../../master/DownloadExcel";
import AttendanceHeader from "./AttendanceHeader";
import { setPrintContent } from "../../../PrintStore";
import { courseList } from "../../../api/Courses";

const Attendance = () => {
  const hasAccess = usePrivateLink();
  const [viewType, setViewType] = useState("day");
  const [selectedAttendance, setSelectedAttendance] = useState("present");
  const [activeTab, setActiveTab] = useState(null);
  const [batch, setBatch] = useState("");
  const [error, setError] = useState("");
  const [selectedBatchId, setSelectedBatchId] = useState("");
  const [students, setStudents] = useState([]);
  const [batchList, setBatchList] = useState([]);

  const [course, setCourse] = useState([]);
  const [selectedCourseId, setSelectedCourseId] = useState("");

  const [selectedDate, setSelectedDate] = useState(
    new Date().toISOString().split("T")[0]
  );
  const [sessions, setSessions] = useState([]);
  const [type, setType] = useState("in"); // default
  const [attendance, setAttendance] = useState({});
  const [attendanceValue, setAttendanceValue] = useState("");
  const [markAllChecked, setMarkAllChecked] = useState(false);
  const [loading, setLoading] = useState(false);
  const [status, setStatus] = useState("");
  // const activeSession =  localStorage.getItem('activeSesson')
  const [selectedSession, setSelectedSessions] = useState("");
  const [page, setPage] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (sessions?.length > 0 && !selectedSession) {
      const activeSessionId = sessions.find((s) => s.status == "1")?.id ?? null;
      setSelectedSessions(activeSessionId);
      console.log("Active Session ID:", activeSessionId);
    }
  }, [sessions]);

  useEffect(() => {
    if (students?.length) {
      const initialAttendance = {};
      students.forEach((student) => {
        initialAttendance[student.id] = "";
      });
      setAttendance(initialAttendance);
    }
  }, [students]);

  const CourseFetch = async () => {
    try {
      const response = await courseList();
      if (response?.data?.status) {
        setCourse(response?.data?.data || []);
      } else {
        setError("Failed to fetch students?.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };
  const studentBatchFetch = async () => {
    setLoading(true);
    try {
      const addUrl = `&session_id=${selectedSession}`;
      const response = await StudentBatchList(addUrl);
      if (response?.data?.success) {
        setBatchList(response?.data || []);
      } else {
        setError("Failed to fetch students?.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    getSession();
    CourseFetch();
  }, []);

  useEffect(() => {
    if (selectedSession) {
      batchliststudent();
    }
  }, [selectedSession, selectedCourseId]);

  const getSession = async () => {
    setLoading(true);
    try {
      const response = await getSessions();
      if (response?.data?.status) {
        const activeSession = response?.data?.data.find(
          (session) => session.status === "1"
        );
        setSelectedSessions(activeSession.id);
        setSessions(response?.data?.data);
        // setSessions(activeSessions);
      } else {
        setError("Failed to fetch session?.");
      }
    } catch (err) {
      setError(err?.response?.data?.message || "Something went wrong");
    } finally {
      setLoading(false);
    }
  };

  const batchliststudent = async () => {
    const addUrl = `&session_id=${selectedSession}&course_id=${selectedCourseId}`;
    setLoading(true);
    try {
      console?.log("Fetching batches with status:", status);
      const response = await viewlist(addUrl);
      console?.log(
        "Batchlist response",
        response?.data?.batches?.[0]?.batch_fees
      );

      if (response?.data?.status) {
        setBatch(response?.data || []);
        console?.log("Batch fetched", response?.data?.batches);
      } else {
        setError("Failed to fetch batches?.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const studentFetch = async () => {
    setLoading(true);
    let addUrl = `&session=${selectedSession}&date=${selectedDate}&page=${page}`;
    if (selectedBatchId) {
      addUrl += `&batch_id=${selectedBatchId}`;
    }
    if (selectedCourseId) {
      addUrl += `&course_id=${selectedCourseId}`;
    }
    if (type === "Present" || type === "Absent") {
      addUrl += `&status=${status}`;
    }
    try {
      const response = await studentsAttendance(addUrl);
      if (response?.data?.status) {
        setStudents(response?.data || []);
      } else {
        setError("Failed to fetch students?.");
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    // Ensure all required filters are selected
    if (selectedSession && selectedDate) {
      studentFetch();
    }
  }, [selectedBatchId, selectedSession, selectedDate, type, selectedCourseId]);

  const handleToggleChange = (e) => {
    const checked = e?.target?.checked;
    const newType = checked ? "in" : "out";
    setType(newType);
    setAttendanceValue(""); // reset on type change

    // Call API immediately for "out"
    if (newType === "out") {
      sendAttendance(newType, null);
    }
  };

  const handlePresentAll = async () => {
    const result = await Swal.fire({
      title: "Mark All Students as Present?",
      text: "Are you sure you want to mark attendance for all students as present?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, mark all",
      cancelButtonText: "No, cancel",
    });

    if (result.isConfirmed) {
      if (Array.isArray(students?.data)) {
        // ✅ Update UI
        const updatedAttendance = {};
        students.data.forEach((student) => {
          updatedAttendance[student.id] = "1";
        });
        setAttendance(updatedAttendance);

        // ✅ One API call for all
        await sendAttendance("in", "1");

        Swal.fire({
          icon: "success",
          title: "All students have been marked as present.",
          timer: 2000,
          showConfirmButton: false,
        }).then(() => {
          studentFetch();
        });
      } else {
        // ToastMain.fire({
        //   icon: 'info',
        //   title: result.data.message || 'something went worng'
        // })
        SweetAlertShow("info", "Warning", result.data.message);
      }
    }
  };

  const handleAbsentAll = () => {
    const updatedAttendance = {};
    students.forEach((student) => {
      updatedAttendance[student.id] = "0";
    });
    setAttendance(updatedAttendance);
  };

  const sendAttendance = () => {
    setLoading(true);
    let addUrl = `&batch_id=${selectedBatchId}&date=${selectedDate}&attendance=${"1"}`;
    try {
      const response = attendanceBatchStudentsPost(addUrl);
      if (response.data.status) {
        SweetAlertShow("success", "Successfully", response?.data?.message);
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const SingleStudentPresent = async ({
    registration_no,
    date,
    attendance,
  }) => {
    setLoading(true);
    // console.log("Payload Sent:", { registration_no, date, attendance });
    const formData = {
      registration_no: registration_no,
      date: date,
      attendance: attendance,
    };
    try {
      const response = await SinglePresent(formData);
      console.log("Payload Sent 2:", { registration_no, date, attendance });

      if (response?.data?.status) {
        ToastMain.fire({
          icon: "success",
          title: response?.data?.message || "Successfully marked attendance",
        }).then(() => studentFetch());
      } else {
        SweetAlertShow("info", "Warning", response?.data?.message);
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ?? error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setMarkAllChecked(false);
  }, [students]);

  const AttendenceMessageSend = async () => {
    setLoading(true);
    let addUrl = `&batch_id=${selectedBatchId}`;
    try {
      const response = await StudentAttendence(addUrl);
      if (response.data.status) {
        SweetAlertShow(
          "success",
          "Successfully",
          response?.data?.message ?? response?.data?.data?.message
        );
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message ?? response?.data?.data?.message
        );
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.data?.data?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };
  const AbsentAttendenceMessageSend = async () => {
    setLoading(true);
    let addUrl = `&batch_id=${selectedBatchId}`;
    try {
      const response = await StudentAttendenceAbsent(addUrl);
      if (response.data.status) {
        SweetAlertShow(
          "success",
          "Successfully",
          response?.data?.message ?? response?.data?.data?.message
        );
      } else {
        SweetAlertShow(
          "info",
          "Warning",
          response?.data?.message ?? response?.data?.data?.message
        );
      }
    } catch (error) {
      SweetAlertShow(
        "error",
        "Error",
        error?.response?.data?.message ??
          error?.response?.data?.data?.message ??
          error?.message
      );
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = () => {
    // Use the correct response data
    const exportData = students?.data || []; // students = response.data from API

    console.log("Students Data: ", exportData); // ✅ Debug log

    if (!Array.isArray(exportData) || exportData.length === 0) {
      alert("No data available to export");
      return;
    }

    // Extract attendance
    const attendanceExport = exportData.flatMap((student, index) => {
      const studentName = student?.student_info?.name || "N/A";
      const batchTitle = student?.batch?.title || "N/A";
      const attendanceArray = student?.student_info?.attendance;

      if (!Array.isArray(attendanceArray) || attendanceArray.length === 0) {
        return [];
      }

      return attendanceArray.map((att) => ({
        SN: index + 1,
        "Student Name": studentName,
        Batch: batchTitle,
        Date: att.date || "N/A",
        "In Time": att.check_in_time || "N/A",
        "Out Time": att.check_out_time || "N/A",
        "Attendance Type": att.check_in === "1" ? "Present" : "Absent",
      }));
    });

    if (attendanceExport.length === 0) {
      alert("No attendance data found.");
      return;
    }

    // Download Excel
    DownloadExcel(
      attendanceExport,
      [
        "SN",
        "Student Name",
        "Batch",
        "Date",
        "In Time",
        "Out Time",
        "Attendance Type",
      ],
      "Daywise Attendance Report"
    );
  };
const handlePrint = () => {
    const printTable = (
      <div className="table-responsive">
        <table className="table table-hover table-sm">
          <thead className="table-primary bg-label-primary">
            <caption className="text-center fw-bold fs-5 mb-2">
              Student Attendance List
            </caption>
            <tr>
              <th>#</th>
              <th>Registration No</th>
              <th>Name</th>
              <th>Mobile</th>
              <th>Course</th>
              <th>Day Attendance</th>
            </tr>
          </thead>

          <tbody>
            {students?.data?.map((student, index) => (
              <tr key={student?.id}>
                <td>{index + 1}</td>
                <td>{student?.student_info?.registration_no || "-"}</td>
                <td>{student?.student_info?.name || "-"}</td>
                <td>{student?.student_info?.phone || "-"}</td>
                <td>{student?.course?.title || "-"}</td>
                <td>
                  {hasAccess('/attendance/present') && (
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name={`attendance-${student?.id}`}
                        id={`present-${student?.id}`}
                        value="1"
                        checked={
                          student?.student_info?.attendance[0]?.check_in ==
                          "1"
                        }
                        onChange={() => {
                          // ✅ Set state for UI
                          setAttendance((prev) => ({
                            ...prev,
                            [student.id]: "1",
                          }));

                          // ✅ Call API with required data
                          SingleStudentPresent({
                            // student_id: student?.student_info?.id,
                            registration_no:
                              student?.student_info?.registration_no,
                            // batch_id: student?.batch_id, // or student?.course?.batch_id if that's your structure
                            date: selectedDate, // today's date (YYYY-MM-DD)
                            // type: "in",
                            attendance: "1",
                          });
                        }}
                      />

                      <label
                        className="form-check-label"
                        htmlFor={`present-${student?.id}`}
                      >
                        Present
                      </label>
                    </div>
                  )}

                  {hasAccess('/attendance/absent') && (
                    <div className="form-check form-check-inline">
                      <input
                        className="form-check-input"
                        type="radio"
                        name={`attendance-${student?.id}`}
                        id={`present-${student?.id}`}
                        value="0"
                        checked={
                          student?.student_info?.attendance[0]?.check_in ==
                          "2"
                        }
                        onChange={() => {
                          // ✅ Set state for UI
                          setAttendance((prev) => ({
                            ...prev,
                            [student.id]: "1",
                          }));

                          // ✅ Call API with required data
                          SingleStudentPresent({
                            // student_id: student?.student_info?.id,
                            registration_no:
                              student?.student_info?.registration_no,
                            // batch_id: student?.batch_id, // or student?.course?.batch_id if that's your structure
                            date: selectedDate, // today's date (YYYY-MM-DD)
                            // type: "in",
                            attendance: "2",
                          });
                        }}
                      />

                      <label
                        className="form-check-label"
                        htmlFor={`present-${student?.id}`}
                      >
                        Absent
                      </label>
                    </div>
                  )}
                </td>
              </tr>
            ))}

            {/* ✅ Submit button only if data exists */}
            {/* {students?.data?.length > 0 && (
                            <tr>
                              <td colSpan="7" style={{ textAlign: 'right' }}>
                                <button className="btn btn-sm btn-primary" onClick={sendAttendance}>Submit</button>
                              </td>
                            </tr>
                          )} */}
          </tbody>
        </table>
      </div>
    );

    setPrintContent(printTable);
    navigate("/print");
  };

  return (
    <>
      {loading && (
        <div
          className="d-flex justify-content-center align-items-center position-fixed top-0 start-0 w-100 h-100"
          style={{ zIndex: 9999 }}
        >
          <div className="sk-chase sk-primary display-1">
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
            <div className="sk-chase-dot" />
          </div>
        </div>
      )}
      <div className="layout-wrapper layout-content-navbar">
        <div className="layout-container">
          <Header />
          <div className="layout-page">
            <Nav />

            <div className="container-fluid mt-2">
              <div className="row custom-scroll-layout">
                <div className=" col-md-2 left-pane">
                  <AttendanceHeader data={"Attendance Portal "} />
                </div>
                <div className="col-12 col-md-10 right-pane">
                  <div className="card p-4 mb-4 shadow-sm ">
                    <div className="d-flex justify-content-between align-items-center flex-wrap mb-4">
                      {/* {activeSession} */}
                      <div className="d-flex gap-2 flex-wrap">
                        {/* <button className="btn btn-warning d-inline-flex align-items-center overflow-hidden  transition-button">
                          <span className="icon">
                            {" "}
                            <i className="bi bi-printer"></i>
                          </span>
                          <span className="text ms-2">Print</span>
                        </button> */}
                        {hasAccess('/attendance/export') && (
                          <button
                            className="btn btn-success btn-sm"
                            onClick={handleDownload}
                            data-bs-toggle="tooltip"
                            data-bs-placement="top"
                            title="Export Excel"
                          >
                            <i className="bi bi-cloud-arrow-down ri-20px"></i>
                          </button>
                        )}
                        {hasAccess('/attendance/print') && (
                          <button
                            className="btn btn-primary"
                            onClick={handlePrint}
                          >
                            Print
                          </button>
                        )}
                        {/* <button className="btn btn-primary" onClick={handlePrint}>
                          Print
                        </button> */}
                      </div>
                    </div>
                    <div className="row ">
                      <div>
                        <div className="container-fluid p-3 ">
                          <div className=" mb-4">
                            <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap"></div>
                            <div className="  rounded-4 ">
                              <form>
                                <div className="row g-3">
                                  <div className="col-md-3 form-floating form-floating-outline">
                                    <select
                                      className="form-select"
                                      name="session"
                                      value={selectedSession}
                                      onChange={(e) =>
                                        setSelectedSessions(e.target.value)
                                      }
                                    >
                                      {/* <option value="">Select Session</option> */}
                                      {sessions?.map((session) => (
                                        <option
                                          key={session?.id}
                                          value={session?.id}
                                        >
                                          {session?.session}:
                                          {session?.status == "1"
                                            ? "Active"
                                            : " Inactive"}
                                          {/* Show "2023-24" */}
                                        </option>
                                      ))}
                                    </select>

                                    <label>Filter Session</label>
                                  </div>

                                  <div className="col-md-3 form-floating form-floating-outline">
                                    <select
                                      className="form-control"
                                      value={selectedCourseId}
                                      onChange={(e) => {
                                        setSelectedCourseId(e.target.value);
                                        setSelectedBatchId("");
                                      }}
                                    >
                                      <option value="">Select Course</option>
                                      {course?.map((course) => (
                                        <option
                                          key={course?.id}
                                          value={course?.id}
                                        >
                                          {course?.title}
                                        </option>
                                      ))}
                                    </select>
                                    <label>Select Course</label>
                                  </div>
                                  <div className="col-md-3 form-floating form-floating-outline">
                                    <select
                                      className="form-control"
                                      onChange={(e) =>
                                        setSelectedBatchId(e.target.value)
                                      }
                                      value={selectedBatchId}
                                      required
                                    >
                                      <option value="">Select Batch</option>
                                      {batch?.batches?.map((batch) => (
                                        <option
                                          key={batch?.id}
                                          value={batch?.id}
                                        >
                                          {batch?.title}
                                        </option>
                                      ))}
                                    </select>
                                    <label>Select Batch</label>
                                  </div>

                                  <div className="col-md-3 form-floating form-floating-outline">
                                    <input
                                      type="date"
                                      className="form-control"
                                      value={selectedDate}
                                      onChange={(e) =>
                                        setSelectedDate(e.target.value)
                                      }
                                      min={
                                        new Date(
                                          Date?.now() - 5 * 24 * 60 * 60 * 1000
                                        )
                                          ?.toISOString()
                                          ?.split("T")[0]
                                      }
                                      max={
                                        new Date()?.toISOString()?.split("T")[0]
                                      }
                                    />
                                    <label> Select Date</label>
                                  </div>
                                  {/*                                   
                                  <div className="col-md-3 form-floating form-floating-outline">
                                    <input className="form-control" type="text" placeholder="student search" name="search" value={search} onChange={(e)=>setSearch(e.target.value)} />
                                    <label >search</label>
                                  </div> */}
                                </div>
                              </form>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="card p-4 mb-4 ">
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="mb-4">
                        <div
                          className="btn-group"
                          role="group"
                          aria-label="Attendance Type"
                        >
                          <button
                            type="button"
                            className={`btn ${
                              type === "in"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => {
                              setType("in");
                              setStatus(null);
                            }}
                          >
                            All
                          </button>

                          <button
                            type="button"
                            className={`btn ${
                              type === "Present"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => {
                              setType("Present");
                              setStatus("present");
                            }}
                          >
                            Present
                          </button>

                          <button
                            type="button"
                            className={`btn ${
                              type === "Absent"
                                ? "btn-primary"
                                : "btn-outline-primary"
                            }`}
                            onClick={() => {
                              setType("Absent");
                              setStatus("absent");
                            }}
                          >
                            Absent
                          </button>
                        </div>
                      </div>

                      <div className="d-flex">
                        {selectedBatchId && type == "in" && (
                          <>
                            <div className="me-4 text-end d-flex">
                              {hasAccess('/attendance/present') && (
                                <>
                                  {students?.data?.length > 0 && (
                                    <div className="form-check form-check-inline">
                                      <input
                                        className="form-check-input"
                                        type="radio"
                                        id="presentAll"
                                        name="markAll"
                                        checked={markAllChecked}
                                        onChange={() => {
                                          handlePresentAll();
                                          setMarkAllChecked(true);
                                        }}
                                      />
                                      <label htmlFor="presentAll">
                                        Mark All Present
                                      </label>
                                    </div>
                                  )}
                                </>
                              )}
                            </div>
                          </>
                        )}
                        <strong>Total Students : </strong>

                        <span>{students?.data?.length}</span>
                      </div>
                    </div>

                    {/* Record Selector */}

                    {/* Table */}
                    {type === "in" && (
                      <>
                        <div className="table-responsive">
                          <table className="table table-hover table-sm">
                            <thead className="table-primary bg-label-primary">
                              <tr>
                                <th>#</th>
                                <th>Registration No</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Course</th>
                                <th>Day Attendance</th>
                              </tr>
                            </thead>

                            <tbody>
                              {students?.data?.map((student, index) => (
                                <tr key={student?.id}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {student?.student_info?.registration_no ||
                                      "-"}
                                  </td>
                                  <td>{student?.student_info?.name || "-"}</td>
                                  <td>{student?.student_info?.phone || "-"}</td>
                                  <td>{student?.course?.title || "-"}</td>
                                  <td>
                                    {hasAccess('/attendance/present') && (
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`attendance-${student?.id}`}
                                          id={`present-${student?.id}`}
                                          value="1"
                                          checked={
                                            student?.student_info?.attendance[0]
                                              ?.check_in == "1"
                                          }
                                          onChange={() => {
                                            // ✅ Set state for UI
                                            setAttendance((prev) => ({
                                              ...prev,
                                              [student.id]: "1",
                                            }));

                                            // ✅ Call API with required data
                                            SingleStudentPresent({
                                              // student_id: student?.student_info?.id,
                                              registration_no:
                                                student?.student_info
                                                  ?.registration_no,
                                              // batch_id: student?.batch_id, // or student?.course?.batch_id if that's your structure
                                              date: selectedDate, // today's date (YYYY-MM-DD)
                                              // type: "in",
                                              attendance: "1",
                                            });
                                          }}
                                        />

                                        <label
                                          className="form-check-label"
                                          htmlFor={`present-${student?.id}`}
                                        >
                                          Present
                                        </label>
                                      </div>
                                    )}

                                    {hasAccess('/attendance/absent') && (
                                      <div className="form-check form-check-inline">
                                        <input
                                          className="form-check-input"
                                          type="radio"
                                          name={`attendance-${student?.id}`}
                                          id={`present-${student?.id}`}
                                          value="0"
                                          checked={
                                            student?.student_info?.attendance[0]
                                              ?.check_in == "2"
                                          }
                                          onChange={() => {
                                            // ✅ Set state for UI
                                            setAttendance((prev) => ({
                                              ...prev,
                                              [student.id]: "1",
                                            }));

                                            // ✅ Call API with required data
                                            SingleStudentPresent({
                                              // student_id: student?.student_info?.id,
                                              registration_no:
                                                student?.student_info
                                                  ?.registration_no,
                                              // batch_id: student?.batch_id, // or student?.course?.batch_id if that's your structure
                                              date: selectedDate, // today's date (YYYY-MM-DD)
                                              // type: "in",
                                              attendance: "2",
                                            });
                                          }}
                                        />

                                        <label
                                          className="form-check-label"
                                          htmlFor={`present-${student?.id}`}
                                        >
                                          Absent
                                        </label>
                                      </div>
                                    )}
                                  </td>
                                </tr>
                              ))}

                              {/* ✅ Submit button only if data exists */}
                              {/* {students?.data?.length > 0 && (
                            <tr>
                              <td colSpan="7" style={{ textAlign: 'right' }}>
                                <button className="btn btn-sm btn-primary" onClick={sendAttendance}>Submit</button>
                              </td>
                            </tr>
                          )} */}
                            </tbody>
                          </table>
                        </div>
                      </>
                    )}
                    {type === "Present" && (
                      <>
                        <div className="table-responsive">
                          <table className="table table-hover table-sm">
                            <thead className="table-primary bg-label-primary justify-content-center">
                              <tr>
                                <th>#</th>
                                <th>Registration No</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Course</th>
                                <th>Status</th>
                                <th>Message Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {students?.data?.map((student, index) => (
                                <tr key={student?.id}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {student?.student_info?.registration_no ||
                                      "-"}
                                  </td>
                                  <td>{student?.student_info?.name || "-"}</td>
                                  <td>{student?.student_info?.phone || "-"}</td>
                                  <td>{student?.course?.title || "-"}</td>
                                  <td>Present</td>
                                  <td>
                                    {student?.student_info?.attendance?.[0]
                                      ?.in_message_status == 1 ? (
                                      <span className="text-success fw-semibold">
                                        <i className="fa-solid fa-check-circle me-1"></i>{" "}
                                        Send
                                      </span>
                                    ) : (
                                      <span className="text-danger fw-semibold">
                                        <i className="fa-solid fa-times-circle me-1"></i>{" "}
                                        Failed
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>

                          <div className="mt-5">
                            <div className="card shadow-sm border-0">
                              <div className="card-body">
                                {/* <h5 className="card-title text-primary mb-4">📊 Attendance Summary</h5> */}

                                <ul className="list-group list-group-flush mb-4">
                                  {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <strong>Total Students</strong>
                                    <span className="badge bg-primary rounded-pill">
                                      {students?.data?.length}
                                    </span>
                                  </li> */}

                                  {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <strong>Today Present Students</strong>
                                    <span className="badge bg-success rounded-pill">
                                      {
                                        students?.data?.filter((student) =>
                                          student.student_info?.attendance?.some(
                                            (att) =>
                                              att.date === new Date().toISOString().split("T")[0] &&
                                              att.check_in === "1"
                                          )
                                        ).length
                                      }
                                    </span>
                                  </li> */}

                                  {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <strong>Today Absent Students</strong>
                                    <span className="badge bg-danger rounded-pill">
                                      {students?.data?.length -
                                        students?.data?.filter((student) =>
                                          student.student_info?.attendance?.some(
                                            (att) =>
                                              att.date === new Date().toISOString().split("T")[0] &&
                                              att.check_in === "1"
                                          )
                                        ).length}
                                    </span>
                                  </li> */}
                                </ul>

                                <div className="d-flex">
                                  <div className="text-end">
                                    {hasAccess('/attendance/message/send') && (
                                      <button
                                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
                                        onClick={AttendenceMessageSend}
                                        disabled={loading} // loading me disable
                                      >
                                        {loading ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                            Sending...
                                          </>
                                        ) : (
                                          <>Message send</>
                                        )}
                                      </button>
                                    )}
                                  </div>
                                  {/* <div className="text-end ms-2">
                                    {(permissions?.[0]?.role_id == '1' || permissions?.find((permission) => permission?.route?.frontend_url == '/attendance/message/send')) && (
                                      <button
                                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
                                        onClick={AbsentAttendenceMessageSend}
                                        disabled={loading} 
                                      >
                                        {loading ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                            Sending...
                                          </>
                                        ) : (
                                          <>
                                            Absent Message
                                          </>
                                        )}
                                      </button>
                                    )}
                                  </div> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                    {type === "Absent" && (
                      <>
                        <div className="table-responsive">
                          <table className="table table-hover table-sm">
                            <thead className="table-primary bg-label-primary">
                              <tr>
                                <th>#</th>
                                <th>Registration No</th>
                                <th>Name</th>
                                <th>Mobile</th>
                                <th>Course</th>
                                <th>Status</th>
                                <th>Message Status</th>
                              </tr>
                            </thead>

                            <tbody>
                              {students?.data?.map((student, index) => (
                                <tr key={student?.id}>
                                  <td>{index + 1}</td>
                                  <td>
                                    {student?.student_info?.registration_no ||
                                      "-"}
                                  </td>
                                  <td>{student?.student_info?.name || "-"}</td>
                                  <td>{student?.student_info?.phone || "-"}</td>
                                  <td>{student?.course?.title || "-"}</td>
                                  <td>Absent</td>
                                  <td>
                                    {student?.student_info?.attendance?.[0]
                                      ?.message_status == '1' ? (
                                      <span className="text-success fw-semibold">
                                        <i className="fa-solid fa-check-circle me-1"></i>{" "}
                                        Send
                                      </span>
                                    ) : (
                                      <span className="text-danger fw-semibold">
                                        <i className="fa-solid fa-times-circle me-1"></i>{" "}
                                        Failed
                                      </span>
                                    )}
                                  </td>
                                </tr>
                              ))}

                              {/* ✅ Submit button only if data exists */}
                              {/* {students?.data?.length > 0 && (
                            <tr>
                              <td colSpan="7" style={{ textAlign: 'right' }}>
                                <button className="btn btn-sm btn-primary" onClick={sendAttendance}>Submit</button>
                              </td>
                            </tr>
                          )} */}
                            </tbody>
                          </table>

                          <div className="mt-5">
                            <div className="card shadow-sm border-0">
                              <div className="card-body">
                                {/* <h5 className="card-title text-primary mb-4">📊 Attendance Summary</h5> */}

                                <ul className="list-group list-group-flush mb-4">
                                  {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <strong>Total Students</strong>
                                    <span className="badge bg-primary rounded-pill">
                                      {students?.data?.length}
                                    </span>
                                  </li> */}

                                  {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <strong>Today Present Students</strong>
                                    <span className="badge bg-success rounded-pill">
                                      {
                                        students?.data?.filter((student) =>
                                          student.student_info?.attendance?.some(
                                            (att) =>
                                              att.date === new Date().toISOString().split("T")[0] &&
                                              att.check_in === "1"
                                          )
                                        ).length
                                      }
                                    </span>
                                  </li> */}

                                  {/* <li className="list-group-item d-flex justify-content-between align-items-center">
                                    <strong>Today Absent Students</strong>
                                    <span className="badge bg-danger rounded-pill">
                                      {students?.data?.length -
                                        students?.data?.filter((student) =>
                                          student.student_info?.attendance?.some(
                                            (att) =>
                                              att.date === new Date().toISOString().split("T")[0] &&
                                              att.check_in === "1"
                                          )
                                        ).length}
                                    </span>
                                  </li> */}
                                </ul>

                                <div className="d-flex">
                                  {/* <div className="text-end">
                                    {(permissions?.[0]?.role_id == '1' || permissions?.find((permission) => permission?.route?.frontend_url == '/attendance/message/send')) && (
                                      <button
                                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
                                        onClick={AttendenceMessageSend}
                                        disabled={loading} // loading me disable
                                      >
                                        {loading ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                            Sending...
                                          </>
                                        ) : (
                                          <>
                                            Attendance Message
                                          </>
                                        )}
                                      </button>
                                    )}
                                  </div> */}
                                  <div className="text-end ms-2">
                                    {hasAccess('/attendance/message/send') && (
                                      <button
                                        className="btn btn-outline-primary btn-sm d-flex align-items-center gap-2"
                                        onClick={AbsentAttendenceMessageSend}
                                        disabled={loading} // loading me disable
                                      >
                                        {loading ? (
                                          <>
                                            <span
                                              className="spinner-border spinner-border-sm"
                                              role="status"
                                              aria-hidden="true"
                                            ></span>
                                            Sending...
                                          </>
                                        ) : (
                                          <>Message Send</>
                                        )}
                                      </button>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="layout-overlay layout-menu-toggle"></div>
          <div className="drag-target"></div>
        </div>
      </div>
    </>
  );
};

export default Attendance;
